import logo from './logo.svg';
import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route} from 'react-router-dom';
import Layout from './components/MasterLayout';
import Home from './pages/Home';
import Contact from './pages/Contactus';
import Ourteams from './pages/OurTeam';
import Aboutus from './pages/Aboutus';
import Aos from 'aos';
import 'aos/dist/aos.css';
import OurExpertise from './pages/OurExpertise';
import OurPhilosphy from './pages/OurPhilosphy';
import OurVision from './pages/OurVision';
import OurMission from './pages/OurMission';
import OurServices from './pages/OurServices';
function App() {  
  useEffect(()=>{
    Aos.init({
      duration:1000,
      once:true
    });
  },[]);

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Layout />}>
              <Route index element={<Home />}></Route>
              <Route path="/Contact" element={<Contact />}></Route>
              <Route path='/our-teams' element={<Ourteams />}></Route>
              <Route path="/aboutus" element={<Aboutus />}></Route>
              <Route path='/our-expertise' element={<OurExpertise></OurExpertise>}></Route>
              <Route path='/our-philosphy' element={<OurPhilosphy></OurPhilosphy>}></Route>
              <Route path='/our-vision' element={<OurVision/>}></Route>
              <Route path='/our-mission' element={<OurMission/>}></Route>
              <Route path='/our-services' element={<OurServices/>}></Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;